module.exports = {
    future: {
        removeDeprecatedGapUtilities: true,
        purgeLayersByDefault: true,
    },
    theme: {
        extend: {
            colors: {
                'light': '#E9E9E9',
                'error': '#c0564a',
                'error-light': '#E6BBB7',
                'warn': '#f6993f',
                'warn-light': '#FBD6B2',
                'success-light': '#e6ffe8',
                'disabled': '#edf2f7',
                'disabled-text': '#a6a6a6',

                'primary': {
                    50: 'var(--primary-50)',
                    100: 'var(--primary-100)',
                    200: 'var(--primary-200)',
                    300: 'var(--primary-300)',
                    400: 'var(--primary-400)',
                    500: 'var(--primary-500)',
                    600: 'var(--primary-600)',
                    700: 'var(--primary-700)',
                    800: 'var(--primary-800)',
                    900: 'var(--primary-900)',
                },
                'primary-dark': {
                    50: '#211F21',
                    100: '#211F21',
                    200: '#413E42',
                    300: '#625D63',
                    400: '#837C84',
                    500: '#A29DA3',
                    600: '#B5B1B5',
                    700: '#C7C4C8',
                    800: '#DAD8DA',
                    900: '#ECEBED',
                },
                'secondary': {
                    50: 'var(--secondary-50)',
                    100: 'var(--secondary-100)',
                    200: 'var(--secondary-200)',
                    300: 'var(--secondary-300)',
                    400: 'var(--secondary-400)',
                    500: 'var(--secondary-500)',
                    600: 'var(--secondary-600)',
                    700: 'var(--secondary-700)',
                    800: 'var(--secondary-800)',
                    900: 'var(--secondary-900)',
                },
                'secondary-dark': {
                    50: '#1C1815',
                    100: '#1C1815',
                    200: '#38312A',
                    300: '#54493F',
                    400: '#706254',
                    500: '#8c7a69',
                    600: '#A39587',
                    700: '#BAAFA5',
                    800: '#D1CAC3',
                    900: '#E8E4E1',
                },
                'success': {
                    50: 'var(--success-50)',
                    100: 'var(--success-100)',
                    200: 'var(--success-200)',
                    300: 'var(--success-300)',
                    400: 'var(--success-400)',
                    500: 'var(--success-500)',
                    600: 'var(--success-600)',
                    700: 'var(--success-700)',
                    800: 'var(--success-800)',
                    900: 'var(--success-900)',
                },
                'success-dark': {
                    50: '#1E2C14',
                    100: '#1E2C14',
                    200: '#3B5727',
                    300: '#59833B',
                    400: '#77AF4E',
                    500: '#98c379',
                    600: '#ADCF94',
                    700: '#C1DBAF',
                    800: '#D6E7C9',
                    900: '#EAF3E4',
                },
                'danger': {
                    50: 'var(--danger-50)',
                    100: 'var(--danger-100)',
                    200: 'var(--danger-200)',
                    300: 'var(--danger-300)',
                    400: 'var(--danger-400)',
                    500: 'var(--danger-500)',
                    600: 'var(--danger-600)',
                    700: 'var(--danger-700)',
                    800: 'var(--danger-800)',
                    900: 'var(--danger-900)',
                },
                'danger-dark': {
                    50: '#370C0F',
                    100: '#370C0F',
                    200: '#6E171E',
                    300: '#A5232D',
                    400: '#D43542',
                    500: '#e06c75',
                    600: '#E68991',
                    700: '#ECA7AC',
                    800: '#F3C4C8',
                    900: '#F9E2E3',
                },
                'warning': {
                    50: 'var(--warning-50)',
                    100: 'var(--warning-100)',
                    200: 'var(--warning-200)',
                    300: 'var(--warning-300)',
                    400: 'var(--warning-400)',
                    500: 'var(--warning-500)',
                    600: 'var(--warning-600)',
                    700: 'var(--warning-700)',
                    800: 'var(--warning-800)',
                    900: 'var(--warning-900)',
                },
                'warning-dark': {
                    50: '#301F0E',
                    100: '#301F0E',
                    200: '#603D1D',
                    300: '#8F5C2B',
                    400: '#BF7B3A',
                    500: '#d19a66',
                    600: '#DAAE85',
                    700: '#E3C2A3',
                    800: '#EDD7C2',
                    900: '#F6EBE0',
                },
                'info': {
                    50: 'var(--info-50)',
                    100: 'var(--info-100)',
                    200: 'var(--info-200)',
                    300: 'var(--info-300)',
                    400: 'var(--info-400)',
                    500: 'var(--info-500)',
                    600: 'var(--info-600)',
                    700: 'var(--info-700)',
                    800: 'var(--info-800)',
                    900: 'var(--info-900)',
                },
                'info-dark': {
                    50: '#0F2629',
                    100: '#0F2629',
                    200: '#1E4C52',
                    300: '#2D737B',
                    400: '#3B99A5',
                    500: '#56b6c2',
                    600: '#78C5CE',
                    700: '#9AD3DA',
                    800: '#BBE2E7',
                    900: '#DDF0F3',
                },
                'purple': {
                    50: 'var(--purple-50)',
                    100: 'var(--purple-100)',
                    200: 'var(--purple-200)',
                    300: 'var(--purple-300)',
                    400: 'var(--purple-400)',
                    500: 'var(--purple-500)',
                    600: 'var(--purple-600)',
                    700: 'var(--purple-700)',
                    800: 'var(--purple-800)',
                    900: 'var(--purple-900)',
                },
                'rose': {
                    50: 'var(--rose-50)',
                    100: 'var(--rose-100)',
                    200: 'var(--rose-200)',
                    300: 'var(--rose-300)',
                    400: 'var(--rose-400)',
                    500: 'var(--rose-500)',
                    600: 'var(--rose-600)',
                    700: 'var(--rose-700)',
                    800: 'var(--rose-800)',
                    900: 'var(--rose-900)',
                },
                'olive': {
                    50: 'var(--olive-50)',
                    100: 'var(--olive-100)',
                    200: 'var(--olive-200)',
                    300: 'var(--olive-300)',
                    400: 'var(--olive-400)',
                    500: 'var(--olive-500)',
                    600: 'var(--olive-600)',
                    700: 'var(--olive-700)',
                    800: 'var(--olive-800)',
                    900: 'var(--olive-900)',
                },
                'teal': {
                    50: 'var(--teal-50)',
                    100: 'var(--teal-100)',
                    200: 'var(--teal-200)',
                    300: 'var(--teal-300)',
                    400: 'var(--teal-400)',
                    500: 'var(--teal-500)',
                    600: 'var(--teal-600)',
                    700: 'var(--teal-700)',
                    800: 'var(--teal-800)',
                    900: 'var(--teal-900)',
                },
                'cyan': {
                    50: 'var(--cyan-50)',
                    100: 'var(--cyan-100)',
                    200: 'var(--cyan-200)',
                    300: 'var(--cyan-300)',
                    400: 'var(--cyan-400)',
                    500: 'var(--cyan-500)',
                    600: 'var(--cyan-600)',
                    700: 'var(--cyan-700)',
                    800: 'var(--cyan-800)',
                    900: 'var(--cyan-900)',
                },

                'brand-yellow': {
                    100: 'var(--brand-yellow-100)',
                    200: 'var(--brand-yellow-200)',
                    300: 'var(--brand-yellow-300)',
                    400: 'var(--brand-yellow-400)',
                    500: 'var(--brand-yellow-500)',
                    600: 'var(--brand-yellow-600)',
                },
                'brand-black': {
                    200: 'var(--brand-black-200)',
                    300: 'var(--brand-black-300)',
                    400: 'var(--brand-black-400)',
                    500: 'var(--brand-black-500)',
                },

                'bg-menu': {
                    400: 'var(--bg-menu-400)',
                    500: 'var(--bg-menu-500)',
                    600: 'var(--bg-menu-600)',
                },

                'color-menu': {
                    400:'var(--color-menu-400)',
                    500:'var(--color-menu-500)',
                    600:'var(--color-menu-600)',
                    700:'var(--color-menu-700)',
                },

                'bg': {
                    100: 'var(--color-bg-100)',
                    400: 'var(--color-bg-400)',
                    500: 'var(--color-bg-500)',
                    900: 'var(--color-bg-900)',
                },
                'bg-dark': {
                    100: '#242329',
                    500: '#302F37',
                    900: '#FFFFFF',
                },

                'border': 'var(--color-border)',
                'text': 'var(--color-text)',
                'text-opposite': 'var(--color-text-opposite)',
                'button-text-filled': 'var(--color-button-text-filled)',
                'icon': 'var(--color-icon)',
                'label-primary': 'var(--color-label-primary)',
                'label-secondary': 'var(--color-label-secondary)',

                'border-dark': '#3c3b45',
                'text-dark': '#B1B1B5',
                'text-opposite-dark': '#242329',
                'button-text-filled-dark': '#242329',
                'icon-dark': '#6c6969',
                'label-primary-dark': '#63626A',
                'label-secondary-dark': '#3c3b45',

                'bg-sidebar-compact-menu': 'var(--bg-sidebar-compact-menu)',
                'bg-active-sidebar-compact-menu-button': 'var(--bg-active-sidebar-compact-menu-button)',
                'bg-hover-sidebar-compact-menu-button': 'var(--bg-hover-sidebar-compact-menu-button)',
                'text-sidebar-compact-menu-button': 'var(--text-sidebar-compact-menu-button)',
                'text-active-sidebar-compact-menu-button': 'var(--text-active-sidebar-compact-menu-button)',
                'bg-login-brand-panel': 'var(--bg-login-brand-panel)',
            },
            maxHeight: {
                '10': '10rem',
                '2/3': '66vh',
            },
            height: {
                '9': '2.25rem'
            },
            fontSize: {
                'xxs': 'var(--size-xxs)',
                'xs': 'var(--size-xs)',
                'sm': 'var(--size-sm)',
                'base': 'var(--size-base)',
                'lg': 'var(--size-lg)',
                'xl': 'var(--size-xl)',
                '2xl': 'var(--size-2xl)',
                '3xl': 'var(--size-3xl)',
                '4xl': 'var(--size-4xl)',
            },
            fontWeight: {
                light: 300,
                normal: 400,
                semibold: 600,
                bold: 700,
                extrabold: 800,
            },
            borderRadius: {
                'none': '0',
                default: '4px',
                'lg': '6px',
                'full': '9999px',
            },
            screens: {
                'xxl': '1537px',
            }
        },
        borderColor: theme => ({
            ...theme('colors'),
            default: theme('colors.border', 'currentColor'),
        }),
    },
    variants: {
        borderWidth: ['responsive', 'hover', 'focus'],
        backgroundColor: ['responsive', 'hover', 'focus', 'active', 'dark', 'dark-hover'],
        textColor: ['responsive', 'hover', 'focus', 'active', 'dark', 'dark-hover'],
        borderColor: ({ after }) => after(['dark', 'dark-hover']),
    },
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    plugins: [require('tailwindcss-dark-mode')()],
}
